module.exports = __webpack_public_path__ + "img/outsourcing.a2e1bbf0.svg";